module.exports = __webpack_public_path__ + "static/headbg-e4c5917635adaa2cee036c9df95aca28.png";